import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'

import { apiFetch } from 'lib/action-helpers'
import { delegationPaths as paths, DELEGATIONS_LIST, DELEGATION_ACTIVE, useDelegationsQuery } from './index'
import { useOrganization } from 'hooks/context/organization-context'

const updateDelegation = async (account, identity, payload) => {
  const data = await apiFetch(paths.delegation(account, identity), { method: 'PUT', body: JSON.stringify(payload) })
  return data
}

export const useUpdateDelegationQuery = () => {
  const queryClient = useQueryClient()
  const { delegationId } = useParams()
  const { account } = useOrganization()

  const { data: delegations } = useDelegationsQuery()
  const identity = delegationId || (delegations && delegations[0]?.id)

  return useMutation(
    ({ payload, delegation }) => updateDelegation(account.id, delegation || identity, payload),
    {
      onMutate: ({ payload }) => {
        const openDelegation = queryClient.getQueryData([...DELEGATION_ACTIVE, identity])

        queryClient.setQueryData([...DELEGATION_ACTIVE, identity], { ...openDelegation, ...payload })
        return openDelegation
      },
      onError: (err, newItem, context) => {
        if (err) {
          queryClient.setQueryData([...DELEGATION_ACTIVE, identity], context.openDelegation)
        }
      },
      onSuccess: () => {
        queryClient.invalidateQueries([...DELEGATIONS_LIST, account.id])
        queryClient.invalidateQueries([...DELEGATION_ACTIVE, identity])
      }
    }
  )
}
